import type { CSSProperties } from 'react';

/**
 * Full-width flex host for shell loading surfaces inside `.emp-main`.
 *
 * Cross-axis `margin: auto` on a flex child cancels stretch alignment and
 * shrink-wraps to content width (~logo + spinner). Loaders must use this host
 * and center their card on the inner element instead.
 */
export function shellLoadingHostStyle(): CSSProperties {
	return {
		width: '100%',
		alignSelf: 'stretch',
		minWidth: 0,
		flex: '1 1 0',
		minHeight: 0,
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		boxSizing: 'border-box',
		padding: '24px',
	};
}
